module.exports = __webpack_public_path__ + "static/img/IMG_20241023_165113.a77494cd.jpg";